const __WEBPACK_NAMESPACE_OBJECT__ = require("use-sync-external-store/shim");